import type { FC } from 'react';
import type { SubmissionShort } from '@queries/fetchSubmissions';
import { clsx } from 'clsx';
import pluralize from 'pluralize';

import { SelectedContractRow } from '../components';

interface SelectedContractsBasketProps {
  removeContract: (contractId: string) => void;
  selectedContracts: SubmissionShort[];
}

export const SelectedContractsBasket: FC<SelectedContractsBasketProps> = ({
  selectedContracts = [],
  removeContract,
}) => {
  'use memo';
  const selectedCount = selectedContracts.length;
  return (
    <div className="w-[390px] min-w-0 shrink-0 pt-2" data-testid="selected-contracts-basket">
      <p className="text-info-900 text-base leading-6 font-medium">
        {selectedCount} Selected {pluralize('contract', selectedCount)}
      </p>
      <div className="border-info-300 mt-4 h-[276px] w-full min-w-0 overflow-y-auto rounded-md border p-2">
        {selectedContracts.map((contract, index) => (
          <div key={contract.id} className={clsx('w-full min-w-0', index > 0 && 'mt-1')}>
            <SelectedContractRow contract={contract} onRemove={removeContract} />
          </div>
        ))}
      </div>
    </div>
  );
};
